import { render, staticRenderFns } from "./AdminMenuPage.vue?vue&type=template&id=0b2e03f0&"
import script from "./AdminMenuPage.vue?vue&type=script&lang=ts&"
export * from "./AdminMenuPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports